<template>
  <div class="statistics-table__row  _head">
    <StatisticsPageTableHeadCellPartner :name="cells[PARTNER_CELL_KEY]"
                                        :routeKey="FILTER_PARTNER"
                                        :apiLink="'/api/cabinet/agent/stats/partners'"
                                        class="statistics-table__cell  _head  _partner"/>
    <div v-for="(value, key, index) in mainCells"
         :key="key"
         @mouseenter="$emit('enter-cell', index)"
         @mouseleave="$emit('leave-cell', index)"
         @click="$emit('sort', key)"
         class="statistics-table__cell  _head">
      {{ value }}
      <div :class="{
        '_to-top': currentSort.key === key && currentSort.toTop,
        '_to-bottom': currentSort.key === key && !currentSort.toTop,
      }"
           class="statistics-table__cell-arrows">

      </div>
    </div>
  </div>
</template>

<script>
  import StatisticsPageTableHeadCellPartner from "./StatisticsPageTableHeadCellPartner"

  export default {
    name: 'StatisticsPageTableHead',
    components: {
      StatisticsPageTableHeadCellPartner,
    },
    inject: [
      'FILTER_PARTNER',
      'PARTNER_CELL_KEY'
    ],
    props: {
      cells: Object,
      mainCells: Object,
      currentSort: Object,
    },
    computed: {

    }
  }
</script>

<style lang="less">

</style>
